/* @flow */
import OrganizationAvatarWithText from './OrganizationAvatarWithText';

export default OrganizationAvatarWithText;
